import type { TabCode, TabRedDotDTO } from '@/api/tabRedDot'
import type { AiUnreadCardTargetDTO } from '@/api/tabRedDot'

export const TAB_CODE_BY_PATH: Readonly<Record<string, TabCode>> = {
  '/bill': 'BILL',
  '/details': 'DETAILS',
  '/chat': 'AI',
}

export const createEmptyTabRedDots = (): Record<TabCode, boolean> => ({
  BILL: false,
  DETAILS: false,
  AI: false,
})

export const normalizeTabRedDots = (items: TabRedDotDTO[]) => {
  const result = createEmptyTabRedDots()
  for (const item of items) {
    if (item.tabCode in result) result[item.tabCode] = Boolean(item.hasRedDot)
  }
  return result
}

export const applyClearResult = (current: boolean, backendCleared: boolean) =>
  backendCleared === true ? false : current

export const hasExplicitCardTarget = (query: Record<string, unknown>) =>
  Boolean(query.sessionId && query.contentId && query.cardId)

export const shouldRestoreChatScroll = (query: Record<string, unknown>) =>
  !hasExplicitCardTarget(query)

export const shouldConsumeAiTarget = (tabCode: TabCode, hasRedDot: boolean, query: Record<string, unknown>) =>
  tabCode === 'AI' && hasRedDot && !hasExplicitCardTarget(query)

export const mergeAiUnreadTarget = <T extends Record<string, unknown>>(
  query: T,
  target: AiUnreadCardTargetDTO | null,
): T | (T & AiUnreadCardTargetDTO & { unreadCard: string }) =>
  hasExplicitCardTarget(query) || !target
    ? query
    : { ...query, ...target, unreadCard: '1' }

export const clearAiUnreadTarget = <T extends Record<string, unknown>>(query: T): Omit<T, 'sessionId' | 'contentId' | 'cardId' | 'unreadCard'> => {
  const { sessionId: _sessionId, contentId: _contentId, cardId: _cardId, unreadCard: _unreadCard, ...rest } = query
  return rest
}

export const isTabRedDotResponseCurrent = (requestRevision: number, currentRevision: number): boolean =>
  requestRevision === currentRevision

export const getTabTargetQuery = <T extends Record<string, unknown>>(tabCode: TabCode, query: T) =>
  tabCode === 'AI' ? query : clearAiUnreadTarget(query)
